import React from 'react';
import loadable from 'react-loadable';
import {Redirect, Route, Switch} from 'react-router-dom';
import {Spin} from 'antd';

export const loadableEmbellish = (loader: any) => {
    return loadable({
        loader,
        loading: () => (
            <Spin
                spinning
                size="large"
                tip="模块加载中..."
                className="component-spin" />
        ),
        timeout: 10000
    });
};

const Home = loadableEmbellish(() => import(/* webpackChunkName: "home" */'@containers/home'));
const NoPermission = loadableEmbellish(() => import(/* webpackChunkName: "no-permission" */'@components/no-permission'));
const Notifications = loadableEmbellish(() => import(/* webpackChunkName: "notifications" */'@containers/notifications'));
const MineNewsBook = loadableEmbellish(() => import(/* webpackChunkName: "notifications" */'@containers/mine_news_book'));
const MineBookMark = loadableEmbellish(() => import(/* webpackChunkName: "minebookmark" */'@containers/mine-book-mark'));
const QuestionLife = loadableEmbellish(() => import(/* webpackChunkName: "notifications" */'@components/question-life'));
const QuestionDetail = loadableEmbellish(() => import(/* webpackChunkName: "question-detail" */'@containers/answer-questions/question-detail'));
const ImgPreview =loadableEmbellish(() => import(/* webpackChunkName: "question-detail" */'@components/answer-question/img-preview'));
const Player =loadableEmbellish(() => import(/* webpackChunkName: "question-detail" */'@components/answer-question/video/player-wx'));
const MoreData =loadableEmbellish(() => import(/* webpackChunkName: "question-detail" */'@containers/moredata'));
const StudentRecord =loadableEmbellish(() => import(/* webpackChunkName: "student-record" */'@containers/student/record'));
const QuestionList =loadableEmbellish(() => import(/* webpackChunkName: "question-list" */'@containers/answer-questions/question-list'));
const PersonalTrainerBookingList =loadableEmbellish(() => import(/* webpackChunkName: "question-list" */'@containers/personal-trainer-booking/personal-trainer-booking-list'));
const RootRoute: React.FC<any> = props => {
    const {isSuperAdmin, hasPermissionWithoutSA, roles, userId} = props.userRole;
    return (
        <Switch>
            <Route
                path="/notifications"
                render={(p: any) => {
                    // if (isSuperAdmin || hasPermissionWithoutSA) {
                    return <Notifications {...p} />;
                    // }
                    // return <NoPermission />;
                }} />
            <Route
                path="/mine-news-book"
                render={(p: any) => {
                    // if (isSuperAdmin || hasPermissionWithoutSA) {
                    return <MineNewsBook {...p} />;
                    // }
                    // return <NoPermission />;
                }} />
            <Route
                path="/mine-book-mark"
                render={(p: any) => {
                    if (isSuperAdmin || hasPermissionWithoutSA) {
                        return <MineBookMark {...p} />;
                    }
                    return <NoPermission />;
                }} />
            <Route
                exact
                path="/question-life/:id"
                render={(p: any) => {
                    // if (isSuperAdmin || hasPermissionWithoutSA) {
                    return <QuestionLife {...p} />;
                    // }
                    // return <NoPermission />;
                }} />
            <Route
                exact
                path="/question-detail/:askId"
                render={(p: any) => {
                    // if (isSuperAdmin || hasPermissionWithoutSA) {
                    return (
                        <QuestionDetail
                            roles={roles}
                            userId={userId}
                            {...p} />
                    );
                    // }
                    // return <NoPermission />;
                }} />
            <Route
                exact
                path="/img-preview"
                render={() => <ImgPreview />
                } />
            <Route
                exact
                path="/player"
                render={() => <Player />
                } />
            <Route
                path="/student/record/:studentId"
                component={StudentRecord} />
            <Route
                path="/question/list"
                component={QuestionList} />
            <Route
                path="/personal/trainer/booking/list"
                component={PersonalTrainerBookingList} />
            <Route
                path="/moredata"
                component={MoreData} />
            <Route
                path="/"
                render={(p: any) => {
                    // if (isSuperAdmin || hasPermissionWithoutSA) {
                    return <Home {...p} />;
                    // }
                    // return <NoPermission />;
                }} />
            <Route path="*">
                <Redirect to="/" />
            </Route>
        </Switch>
    );
};

export default RootRoute;



